import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { studentSchoolsManagement } from "../../../../../../hooks/api/StudentSchoolsManagement/StudentSchoolsManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";

const AddSchool = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddStudentSchoolsMutation } = studentSchoolsManagement;
    const [addSchool, { isLoading: isAddingSchool }] = useAddStudentSchoolsMutation();

    const tabs = [
        { title: t("schools.title"), isActive: true },
        { title: t("certificates.title"), onClick: () => gotoCertificateTab() },
        { title: t("address.title"), onClick: () => gotoAddressTab()},
    ];

    const gotoCertificateTab = () => {
        navigate("/settings/students/certificates");
    };

    const gotoAddressTab = () => {
        navigate("/settings/students/address");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addSchool(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/students/schools");
            }
        });
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/students/schools" />
                <Button title={t("save")} isDisabled={isAddingSchool} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("students.title")} />
                    <Link title={t("schools.title")} />
                    <Link title={t("schools.addNew")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("schools.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>                     
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddSchool;